import { forEach, every, keys, camelCase } from 'lodash';
import VALIDATION from '@/utils/validationFields';
import { ErrorsInterface, ResponseData } from '@/types';
import { Audience, ESource } from '@/types/audience/audience';

const clearErrors = (errors: ErrorsInterface): void => {
  forEach(errors, (value: Array<string | undefined>): void => {
    value.splice(0, value.length);
  });
};

const validateAudienceForm = (audience: Audience): boolean => {
  let isValid = true;
  clearErrors(audience.errors);

  VALIDATION.required(audience.name, audience.errors.name);
  if (audience.source === ESource.VISITORS) {
    VALIDATION.required(String(audience.pixelIds), audience.errors.pixelIds);
  }

  const errors = every(audience.errors, error => error.length === 0);
  isValid = errors ? isValid : errors;

  return isValid;
};

const setAudienceErrorsFromResponseData = (
  errors: Array<ResponseData>,
  audience: Audience
): void => {
  if (!errors?.length) return;
  const errorProps = keys(audience.errors);

  forEach(errors, error => {
    const field = camelCase(error.field);
    if (errorProps.includes(field)) {
      audience.errors[field].push(error.message);
    }
  });
};

export { validateAudienceForm, setAudienceErrorsFromResponseData };
